import React, { useState, useEffect, useRef } from 'react';
import './styles.scss';

// Custom hook for scroll animations
const useInView = (options = {}) => {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        if (options.once !== false) {
          observer.unobserve(entry.target);
        }
      } else if (options.once === false) {
        setIsInView(false);
      }
    }, {
      threshold: options.threshold || 0.2,
      rootMargin: options.rootMargin || '0px'
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return [ref, isInView];
};

const FightScout = () => {
  // Animation refs
  const [promoRef, promoInView] = useInView({ threshold: 0.3, rootMargin: '-80px 0px' });
  const [dashboardRef, dashboardInView] = useInView({ threshold: 0.3, rootMargin: '-80px 0px' });
  const [textRef, textInView] = useInView({ threshold: 0.5, rootMargin: '-50px 0px' });

  return (
    <section className="fightscout-section">
      {/* Black wave background */}
      <div className="fightscout-background">
        <img 
          src="/2025/fightScout/images/background.png"
          alt="" 
          className="wave-bg"
        />
      </div>
      
      <div className="fightscout-content">
        <div className="visuals-row">
          {/* Left - Phone/Promo mockup */}
          <div 
            ref={promoRef}
            className={`promo-mockup animate-fade-up ${promoInView ? 'is-visible' : ''}`}
          >
            <img 
              src="/2025/fightScout/images/fightScout.svg" 
              alt="FightScout BKFC Rome" 
              loading="lazy"
            />
            <div className="store-badges">
              <a href="#" className="store-badge">
                <img src="/2025/fightScout/icons/apple.png" alt="Download on the App Store" />
              </a>
              <a href="#" className="store-badge">
                <img src="/2025/fightScout/icons/google.png" alt="Get it on Google Play" />
              </a>
            </div>
          </div>
          
          {/* Right - Dashboard screenshot */}
          <div 
            ref={dashboardRef}
            className={`dashboard-mockup animate-slide-right ${dashboardInView ? 'is-visible' : ''}`}
          >
            <img 
              src="/2025/fightScout/images/appMockup.png" 
              alt="FightScout Dashboard" 
              loading="lazy"
            />
          </div>
        </div>
        
        {/* Single text */}
        <div 
          ref={textRef}
          className={`fightscout-text animate-fade-up ${textInView ? 'is-visible' : ''}`}
        >
          <p>
            Дигиталната платформа за професионалисти в бойните спортове за представяне, свързване, развитие и излъчване в рамките на индустрията. През изминалата година увеличихме обхвата на потребители по света, а през 2026-та ще публикуваме невиждани досега в индустрията иновации.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FightScout;
